import NamedDto from 'modules/base/dto/NamedDto';

export class ExpressionModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.value = null;
		/** @type {number} */
		this.minValue = null;
		/** @type {number} */
		this.maxValue = null;
		/** @type {string} */
		this.uom = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _ExpressionModelInputAttributeEditDtoProps
	 * @property {number} value
	 * @property {number} minValue
	 * @property {number} maxValue
	 * @property {string} uom
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ExpressionModelInputAttributeEditDtoProps} ExpressionModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {ExpressionModelInputAttributeEditDtoProps} props
	 * @returns {ExpressionModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.value = props.value;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		this.uom = props.uom;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default ExpressionModelInputAttributeEditDto;
